import React from "react";
import { motion , useAnimation } from "framer-motion";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import { BounceLoader } from "react-spinners";

export default function Email(){
    const[sent,setSent] = React.useState(false);
    const inputControls = useAnimation()
    const nameRef = useRef(null);
    const mailRef = useRef(null);
    const msgRef = useRef(null);


    function sendMail(event){
        event.preventDefault();
        let nameValue = nameRef.current.value;
        let mailValue = mailRef.current.value;
        let msgValue = msgRef.current.value;

        if(nameValue==="" || mailValue==="" || msgValue===""){
            inputControls.start('shaking');
        }
        else{
            setSent(true);
            const templateParams = {
                from_name : nameValue,
                email_id : mailValue,
                message : msgValue
            };

            emailjs.send('service_4utum7d','template_ueil0qd', templateParams, 'p_Z8zBejoQJYcW2UE')
            .then((response) => {
               console.log('SUCCESS!', response.status, response.text);
            }, (err) => {
               console.log('FAILED...', err);
            })
            .finally(()=>{
                setTimeout(()=>{
                    setSent(false);
                    if(nameRef.current) nameRef.current.value = "";
                    if(mailRef.current) mailRef.current.value = "";
                    if(msgRef.current) msgRef.current.value = "";
                },4000)
            });
        }

    }

    const inputVariants = {
        shaking: {
          x: [-10, 10, -10, 10, 0],
          transition: {
            duration: 0.4,
          },
        },
      };
    return (
        <div id="emailRoot">
            {
                sent?
                <motion.div id="sending" initial={{opacity:0}} animate={{opacity:1}} transition={{duration:2}} role="status" aria-live="polite">
                <motion.h3 id="sendingText">Sending...</motion.h3>
                <BounceLoader
                  height="80"
                  width="80"
                  radius="9"
                  color="#a855f7"
                  aria-label="loading"
                />
                </motion.div>
                :
                <form onSubmit={sendMail} noValidate>
               <label htmlFor="contactName" className="visually-hidden">Name</label>
               <motion.input variants={inputVariants} animate={inputControls} ref={nameRef} id="contactName" name="name" placeholder="Name" autoComplete="name"/>
               <label htmlFor="contactEmail" className="visually-hidden">Email</label>
               <motion.input variants={inputVariants} animate={inputControls} ref={mailRef} id="contactEmail" name="email" type="email" placeholder="Email" autoComplete="email"/>
               <label htmlFor="contactMessage" className="visually-hidden">Message</label>
               <motion.textarea variants={inputVariants} animate={inputControls} ref={msgRef} id="contactMessage" name="message" placeholder="Message"/>
               <motion.button type="submit" whileHover={{scale:1.1}} id="contactButton">Get in touch</motion.button>
                </form>
            }


        </div>
    )
}
